import { render, staticRenderFns } from "./VIPclassxqPartner.vue?vue&type=template&id=22b06a8e&scoped=true"
import script from "./VIPclassxqPartner.vue?vue&type=script&lang=js"
export * from "./VIPclassxqPartner.vue?vue&type=script&lang=js"
import style0 from "./VIPclassxqPartner.vue?vue&type=style&index=0&id=22b06a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b06a8e",
  null
  
)

export default component.exports